/* Project Import will be here */
import { getErrorObject, errorToast } from "../../utilities/utils";
import { IRewardsHistoryParams, IRewardsHistoryDetailsParams } from "../../models/rewardModels";
import { IOrderHistoryFilterParams } from "models/orderModels";

import Constants from "utilities/appConstants";
import { showMsgFromJson } from "reducers/common";
import { getRewardsOrderHistoryApi, getRewardHistoryDetailsApi } from "services/rewards/rewards";
import { navigateToRewardHistory } from "app/navigation";
/* Project Import will be here */

export const types = {
    REWARDS_HISTORY_REQUEST: "rewardHistory/REWARDS_HISTORY_REQUEST",
    REWARDS_HISTORY_SUCCESS: "rewardHistory/REWARDS_HISTORY_SUCCESS",
    REWARDS_HISTORY_FAILURE: "rewardHistory/REWARDS_HISTORY_FAILURE",
    REWARDS_HISTORY_DETAIL_REQUEST: "rewardHistory/REWARDS_HISTORY_DETAIL_REQUEST",
    REWARDS_HISTORY_DETAIL_SUCCESS: "rewardHistory/REWARDS_HISTORY_DETAIL_SUCCESS",
    REWARDS_HISTORY_DETAIL_FAILURE: "rewardHistory/REWARDS_HISTORY_DETAIL_FAILURE"
};

const initialState = {
    list: {
        data: [],
        isLoading: false,
        error: null
    },
    details: {
        redemptionId: null,
        summary: {},
        productList: [],
        isLoading: false,
        error: null
    }
};

export const rewardsHistory = (state = initialState, action) => {
    switch (action.type) {
        case types.REWARDS_HISTORY_REQUEST:
            return {
                ...state,
                list: {
                    ...state.list,
                    isLoading: true
                }
            };
        case types.REWARDS_HISTORY_SUCCESS:
            return {
                ...state,
                list: {
                    ...state.list,
                    ...action.payload,
                    isLoading: false,
                    error: null
                }
            };
        case types.REWARDS_HISTORY_FAILURE:
            return {
                ...state,
                list: {
                    ...state.list,
                    ...action.payload,
                    data: [],
                    isLoading: false,
                    error: action.payload.error
                }
            };
        case types.REWARDS_HISTORY_DETAIL_REQUEST: {
            return {
                ...state,
                details: {
                    ...state.details,
                    ...action.payload,
                    isLoading: true
                }
            };
        }
        case types.REWARDS_HISTORY_DETAIL_SUCCESS: {
            return {
                ...state,
                details: {
                    ...state.details,
                    ...action.payload,
                    isLoading: false,
                    error: null
                }
            };
        }
        case types.REWARDS_HISTORY_DETAIL_FAILURE: {
            return {
                ...state,
                details: {
                    ...state.details,
                    ...action.payload,
                    isLoading: false
                }
            };
        }
        default:
            return state;
    }
};

/* Get rewards history */
export const getRewardsHistory = (value: IRewardsHistoryParams) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.REWARDS_HISTORY_REQUEST });
        try {
            const hFilter = getState().historyFilter;
            const requestObj: IOrderHistoryFilterParams = {
                SearchText: hFilter.searchText,
                FromDate: hFilter.month !== null ? hFilter.monthStartDate : hFilter.startDate,
                ToDate: hFilter.month !== null ? hFilter.monthEndDate : hFilter.endDate
            }

            const response = await getRewardsOrderHistoryApi(requestObj);

            dispatch({
                type: types.REWARDS_HISTORY_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.REWARDS_HISTORY_FAILURE));

        }
    }
};

/* Get reward history details */
export const getRewardsHistoryDetails = (data: IRewardsHistoryDetailsParams) => {
    return async dispatch => {
        dispatch({
            type: types.REWARDS_HISTORY_DETAIL_REQUEST,
            payload: { redemptionId: data.RedemptionId }
        });

        try {
            /* Fetch the rewards history details from the server */
            const response = await getRewardHistoryDetailsApi(data);

            const responsePayload = {
                summary: response.data.OrderSummary[0],
                productList: response.data.Data
            };
            dispatch({
                type: types.REWARDS_HISTORY_DETAIL_SUCCESS,
                payload: responsePayload
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.REWARDS_HISTORY_DETAIL_FAILURE, true));

            /* Navigate to rewards history list page */
            dispatch(navigateToRewardHistory());

        }
    };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "") {
            dispatch({
                type: type,
                payload: { error: message }
            });
        }

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};